import { queryOptions } from '@tanstack/react-query'

import {
  fetchGrid,
  fetchMaterials,
  fetchMeetings,
  fetchRooms,
  fetchSessions,
  fetchSpeakerProfiles,
  fetchSpeakers,
  fetchTracks,
} from '#admin/features/program/api.ts'

export const gridQuery = () =>
  queryOptions({
    queryKey: ['business-matching', 'grid'],
    queryFn: ({ signal }) => fetchGrid(signal),
  })

/**
 * The meeting desk refetches on a timer while the page is open.
 *
 * This is the one screen in the console somebody sits in front of during the event, taking
 * requests from delegates who are standing at the desk. A pending count that only moves on
 * reload reads as a queue that has stopped. Thirty seconds rather than a socket: requests arrive
 * at the speed people walk, and the same reasoning as the voting leaderboard applies.
 */
export const meetingsQuery = () =>
  queryOptions({
    queryKey: ['business-matching', 'meetings'],
    queryFn: ({ signal }) => fetchMeetings(signal),
    refetchInterval: 30_000,
  })

export const speakerProfilesQuery = () =>
  queryOptions({
    queryKey: ['business-matching', 'speakers'],
    queryFn: ({ signal }) => fetchSpeakerProfiles(signal),
  })

export const sessionsQuery = () =>
  queryOptions({
    queryKey: ['rundown', 'sessions'],
    queryFn: ({ signal }) => fetchSessions(signal),
  })

export const roomsQuery = () =>
  queryOptions({
    queryKey: ['room', 'rooms'],
    queryFn: ({ signal }) => fetchRooms(signal),
  })

export const tracksQuery = () =>
  queryOptions({
    queryKey: ['rundown', 'tracks'],
    queryFn: ({ signal }) => fetchTracks(signal),
  })

export const speakersQuery = () =>
  queryOptions({
    queryKey: ['rundown', 'speakers'],
    queryFn: ({ signal }) => fetchSpeakers(signal),
  })

/** Read only while a session's dialog is open, so it is not part of any page's loader. */
export const materialsQuery = (sessionId: string) =>
  queryOptions({
    queryKey: ['rundown', 'materials', sessionId],
    queryFn: ({ signal }) => fetchMaterials(sessionId, signal),
  })
